import { LeftOutlined } from "@ant-design/icons";
import {
  AutoCompleteSearch,
  EChartTree,
  LoadingListCard,
  UnitCard,
} from "Explore/Components";
import { IconPack } from "Explore/Config/Icons";
import { getSuggestSearchInstitutions } from "Explore/Services/Institution";
import { Button, Empty, List } from "antd";
import { useState } from "react";
import UnitInformation from "../UnitInformation/UnitInformation";
import styles from "./AcademicUnit.module.scss";

const AcademicUnit = ({
  units,
  landscape,
  institution_name,
  setSection,
  selectedUnitQueue,
  setSelectedUnitId,
  setSelectedUnit,
  setSelectedUnitQueue,
  unitSearchFilter,
  setUnitSearchFilter,
}) => {
  const [displayType, setDisplayType] = useState("list");
  const [fade, setFade] = useState("");

  const grid =
    window.screen.width <= 480
      ? {
          gutter: 25,
          column: 1,
        }
      : window.screen.width <= 1024
      ? {
          gutter: 25,
          column: 2,
        }
      : {
          gutter: 25,
          column: 4,
        };

  function handleOnClickBackButton() {
    if (selectedUnitQueue.length > 1) {
      let lastElement = selectedUnitQueue.at(-2);
      setSelectedUnitId(lastElement.id);
      setSelectedUnit(lastElement.name);
    } else {
      setSelectedUnit(null);
      setSelectedUnitId(null);
    }
    setUnitSearchFilter({
      query: null,
    });
    setSelectedUnitQueue(selectedUnitQueue.slice(0, -1));
  }

  return (
    <div className={`${styles["academic-units"]}  ${styles[fade]}`}>
      {displayType == "treeMap" ? (
        <div className={styles["e-chart"]}>
          <div className={styles["instruction"]}>
            {IconPack.information}
            <p>
              Click to zoom into a specific unit; Hover over the nodes to view a
              brief summary of the unit; Double-click on the unit to view
              detailed information.
            </p>
          </div>
          <EChartTree
            data={units}
            institution_name={institution_name}
            setFade={setFade}
            setSection={setSection}
          />
        </div>
      ) : (
        <div className={`${styles["detail-bio"]} ${styles["scroll-section"]}`}>
          <div className={styles["unit-actions"]}>
            <Button
              type="primary"
              icon={<LeftOutlined />}
              disabled={
                selectedUnitQueue.length == 0 && unitSearchFilter.query == null
              }
              onClick={() => handleOnClickBackButton()}
              className={styles["back-button"]}
            >
              {"Back"}
            </Button>
            <AutoCompleteSearch
              placeholder={"Enter to search"}
              functionSearch={getSuggestSearchInstitutions}
              filters={unitSearchFilter}
              setFilters={setUnitSearchFilter}
              entity="query"
              style={{
                width: "400px",
                borderRadius: "40px",
                height: "35px",
              }}
              callback={() => {
                setSelectedUnit(null);
                setSelectedUnitId(null);
                setSelectedUnitQueue([]);
              }}
            />
          </div>
          <div className={styles["institution-units"]}>
            <UnitInformation
              units={selectedUnitQueue}
              setSection={setSection}
            />
            <LoadingListCard
              isLoading={units.isLoading}
              grid={grid}
              componentNum={12}
              avatar={false}
              component={
                units.data.length > 0 ? (
                  <List
                    grid={grid}
                    dataSource={units.data}
                    renderItem={(item, index) => {
                      return (
                        <List.Item key={index}>
                          <UnitCard
                            unit={item}
                            landscape={landscape}
                            setSelectedUnitId={setSelectedUnitId}
                            setSelectedUnit={setSelectedUnit}
                            selectedUnitQueue={selectedUnitQueue}
                            setSelectedUnitQueue={setSelectedUnitQueue}
                            setUnitSearchFilter={setUnitSearchFilter}
                            setSection={setSection}
                          />
                        </List.Item>
                      );
                    }}
                  />
                ) : (
                  <Empty
                    description={
                      selectedUnitQueue.length >= 1
                        ? `There are no sub-units for the ${
                            selectedUnitQueue[selectedUnitQueue.length - 1].name
                          } unit`
                        : "No Data"
                    }
                  />
                )
              }
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default AcademicUnit;
